export const AnnotationManagerBinding = Symbol('AnnotationManagerBinding');
